export default __webpack_public_path__ + "static/24-ad8628dc01615622637cc28d0d31ecb1.png";